import Locals from "./locals.coffee"

$(document).on 'turbolinks:load', ->
  new Locals().handler_events()